
<template>
  <div v-if="isInit">
    <router-view v-slot="{ Component }">
      <keep-alive>
        <component :is="Component" v-if="$route.meta.keepAlive" />
      </keep-alive>
      <component :is="Component" v-if="!$route.meta.keepAlive" />
    </router-view>
    <!-- <van-back-top right="16" offset="150" /> -->
  </div>
</template>

<script setup>
import { ref } from "vue";
import { getFromList } from "./utils/index";

const isInit = ref(false);
getFromList((res) => {
  isInit.value = true;
});
</script>
<style>
.logo {
  height: 30px;
  padding: 20px;
  will-change: filter;
  transition: filter 300ms;
}
.logo:hover {
  filter: drop-shadow(0 0 12px #646cffaa);
}
.logo.vue:hover {
  filter: drop-shadow(0 0 12px #42b883aa);
}
body {
  -ms-overflow-style: none !important;
  width: 100vw;
  /* overflow: hidden; */
}
::-webkit-scrollbar {
  display: none !important;
}

/* 针对 Firefox */
html {
  scrollbar-width: none !important;
}
</style>
